import React, { Component } from 'react';
import { Form, FormGroup, ControlLabel, ButtonToolbar, Button } from 'react-bootstrap';
import Select from "react-select";

export class TmlExceptionConfigs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                lines: Array.isArray(props.lines) ? props.lines.filter(line => props.linesToRemoveExceptions.includes(line.code)) : [],
            }
        };
    }

    onContinue() {
        const { form } = this.state;

        this.props.onContinue({
            lines: form.lines,
        });
    }

    onSelectValue(e, property) {
        const { form } = this.state;

        form[property] = e;

        this.setState({
            form: form
        });
    }

    onCheckValue(e, property) {
        const { form } = this.state;

        form[property] = e.target.checked;

        this.setState({
            form: form,
        });
    }

    render() {
        const { lines } = this.props;
        const { form } = this.state;

        return (
            <React.Fragment>
                <Form>
                    <FormGroup controlId="formLines">
                        <ControlLabel>Linhas a não considerar excepções</ControlLabel>
                        <Select
                            className="custom-multiselect"
                            placeholder="Sem linhas selecionadas"
                            noOptionsMessage={() => "Sem Linhas Carregadas"}
                            onChange={(e) => this.onSelectValue(e, "lines")}
                            options={lines}
                            isMulti={true}
                            isOptionSelected={function (a) {
                                if (Array.isArray(form.lines)) {
                                    return form.lines.includes(a);
                                }

                                return false;
                            }}
                            getOptionValue={value => value.id}
                            getOptionLabel={label => (
                                <span>{label.code} | {label.name}</span>
                            )}
                            filterOption={(candidate, input) => {
                                if (undefined === input || null === input || "" === input) {
                                    return true;
                                }

                                const inputInvariantCase = input.toLowerCase();
                                const codeInvariantCase = candidate.data.code.toLowerCase();
                                const nameInvariantCase = candidate.data.name.toLowerCase();

                                if (codeInvariantCase.includes(inputInvariantCase) || nameInvariantCase.includes(inputInvariantCase)) {
                                    return true;
                                }

                                return `${codeInvariantCase} | ${nameInvariantCase}`.includes(inputInvariantCase);
                            }}
                            value={form.lines}
                        />
                    </FormGroup>
                </Form>
                <ButtonToolbar>
                    <Button onClick={() => this.onContinue()}> GUARDAR </Button>
                    <Button onClick={() => this.props.onCancel()}> CANCELAR </Button>
                </ButtonToolbar>
            </React.Fragment>
        );
    }
}
